import { ChangeDetectorRef, Component, OnDestroy, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseSiteService, CmsAddToCartComponent, EventService, GlobalMessageService, GlobalMessageType, isNotNullable, TranslatePipe } from '@spartacus/core';
import { CmsComponentData, CurrentProductService, ProductListItemContext } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UdxActiveCartFacade } from 'src/app/udxb2b/facade/udx-active-cart.facade';
import { Udxb2bCalendarFacade } from 'src/app/udxb2b/facade/udxb2b-calendar-facade';
import { UdxCurrentProductService } from 'src/app/udxb2b/services/udx-current-product.service';
import { UdxDataTransferService } from 'src/app/udxb2b/services/udx-data-transfer.service.service';
import { Udxb2bAddToCartComponent } from '../add-to-cart.component';
import { UDXStorefrontConfigService } from 'src/app/udxb2b/utilities/services/udx-storefront-config.service';
import { ReactiveFormsModule } from '@angular/forms';
import { UdxB2bProductSummaryComponent } from '../../product/product-summary/product-summary.component';
import { Udxb2bItemCounterComponent } from '../../item-counter/item-counter.component';

@Component({
    selector: 'cx-add-to-cart',
    templateUrl: './group-sales-details-add-to-cart.component.html',
    styleUrls: ['./group-sales-details-add-to-cart.component.scss'],
    imports: [ReactiveFormsModule, UdxB2bProductSummaryComponent, Udxb2bItemCounterComponent, TranslatePipe]
})
export class UdxGroupSalesDetailsAddToCartComponent extends Udxb2bAddToCartComponent implements OnDestroy {
  sub$ = new Subscription();
  mainProductQuantityMap: Map<string, number> = new Map();
  constructor(
    udxb2bCalendarFacade: Udxb2bCalendarFacade,
    currentProductService: CurrentProductService,
    private udxCurrentProductService: UdxCurrentProductService,
    cd: ChangeDetectorRef,
    activeCartService: UdxActiveCartFacade,
    component: CmsComponentData<CmsAddToCartComponent>,
    eventService: EventService,
    dialog: MatDialog,
    dataTransfer: UdxDataTransferService,
    globalMessageService: GlobalMessageService,
    _baseSiteService: BaseSiteService,
    private _storefrontConfigService: UDXStorefrontConfigService,
    @Optional() productListItemContext?: ProductListItemContext,
  ) {
    super(
      udxb2bCalendarFacade,
      currentProductService,
      cd,
      activeCartService,
      component,
      eventService,
      dialog,
      dataTransfer,
      globalMessageService,
      _baseSiteService,
      productListItemContext
    );
  }

  override ngOnInit(): void {
    this.subscription = (
      this.productListItemContext
        ? this.productListItemContext.product$
        : this.udxCurrentProductService.getGroupProduct()
    )
      .pipe(filter(isNotNullable))
      .subscribe((product) => {
        this.productCode = product.code ?? '';
        this.product = product;
        this.buildDynamicForms();
        //START - Setting the Quantity Map  and subtotal for Group Product
        if (product.isGroupProduct) {
          this.setGroupRuleQuantity();
          this.enableOrDisableBtn();
        }
        this.dataTransfer.updateGroupRuleSubtotal(Number(this.product.groupSubTotal ? this.product.groupSubTotal : 0));
        //END - Setting the Quantity Map for Group Product
        this.cd.markForCheck();
      });
  }

  protected setGroupRuleQuantity() {
    let total = 0;
    // Group Main Product should always have variants - This is the assumption (13/08/2023)
    this.product.variantOptions?.forEach((variant) => {
      if (!this.stepperBtnDisabled(variant.stock)) {
        this.mainProductQuantityMap.set(variant.code!, variant.selectedQuantity ? variant.selectedQuantity : 0);
        total = total + variant.startingPrice?.value! * (variant.selectedQuantity ? variant.selectedQuantity : 0);
      }
    });
    if (
      this.product.groupRuleAddonMealProduct &&
      (this.product.groupRuleAddonMealProduct.code || this.product.groupRuleAddonMealProduct?.variantOptions)
    ) {
      if (
        this.product.groupRuleAddonMealProduct?.variantOptions != undefined &&
        this.product.groupRuleAddonMealProduct?.variantOptions.length > 0
      ) {
        this.product.groupRuleAddonMealProduct?.variantOptions.forEach((variant) => {
          if (!this.stepperBtnDisabled(variant.stock)) {
            this.mainProductQuantityMap.set(
              variant.code + '#mealAddon',
              variant.selectedQuantity ? variant.selectedQuantity : 0
            );
            total = total + variant.startingPrice?.value! * (variant.selectedQuantity ? variant.selectedQuantity : 0);
          }
        });
      } else {
        this.mainProductQuantityMap.set(
          this.product.groupRuleAddonMealProduct.code + '#mealAddon',
          this.product.groupRuleAddonMealProduct.selectedQuantity
            ? this.product.groupRuleAddonMealProduct.selectedQuantity
            : 0
        );
        total =
          total +
          this.product.groupRuleAddonMealProduct.price?.value! *
            (this.product.groupRuleAddonMealProduct?.selectedQuantity
              ? this.product.groupRuleAddonMealProduct?.selectedQuantity
              : 0);
      }
    }
    if (
      this.product.groupRuleAddonProduct &&
      (this.product.groupRuleAddonProduct?.variantOptions || this.product.groupRuleAddonProduct.code)
    ) {
      if (
        this.product.groupRuleAddonProduct?.variantOptions != undefined &&
        this.product.groupRuleAddonProduct?.variantOptions.length > 0
      ) {
        this.product.groupRuleAddonProduct?.variantOptions.forEach((variant) => {
          if (!this.stepperBtnDisabled(variant.stock)) {
            this.mainProductQuantityMap.set(
              variant.code + '#addonProduct',
              variant.selectedQuantity ? variant.selectedQuantity : 0
            );
            total = total + variant.startingPrice?.value! * (variant.selectedQuantity ? variant.selectedQuantity : 0);
          }
        });
      } else {
        this.mainProductQuantityMap.set(
          this.product.groupRuleAddonProduct.code + '#addonProduct',
          this.product.groupRuleAddonProduct.selectedQuantity ? this.product.groupRuleAddonProduct.selectedQuantity : 0
        );
        total =
          total +
          this.product.groupRuleAddonProduct?.price?.value! *
            (this.product.groupRuleAddonProduct.selectedQuantity
              ? this.product.groupRuleAddonProduct.selectedQuantity
              : 0);
      }
    }
    this.subtotal.next(total);
    this.dataTransfer.updateGroupProdQuantity(this.mainProductQuantityMap);
    this.dataTransfer.updateGroupRuleSubtotal(total);
    this.setSelectedQuantity();
  }

  setSelectedQuantity() {
    this.product.variantOptions?.forEach((variant) => {
      const qty = this.stepperBtnDisabled(variant.stock) ? 0 : variant.selectedQuantity ? variant.selectedQuantity : 0;
      this.addToCartForm.get(variant.code!)?.setValue(qty);
    });
  }

  onGroupRuleQuantityChange(quantity: number, code: string) {
    if (!this._storefrontConfigService.usjfeature) {
      this.enableOrDisableBtn();
    }
    let totalSelectedQty = 0;
    this.product.variantOptions?.forEach((variant) => {
      totalSelectedQty = (totalSelectedQty + this.addToCartForm.get(variant.code!)?.value) as number;
    });
    if (this.product.groupRuleMaxQty && totalSelectedQty > this.product.groupRuleMaxQty) {
      const params = { min: this.product.groupRuleMinQty, max: this.product.groupRuleMaxQty };
      this.globalMessageService.add({ key: 'groupSalesPDP.quantityerror', params }, GlobalMessageType.MSG_TYPE_ERROR);
    }
    var shouldResetDateSelectionOnQtyChange = true;
    if (this.product.isSavedGroupCart) {
      shouldResetDateSelectionOnQtyChange = false;
    }
    this.dataTransfer.resetSelectedDate(shouldResetDateSelectionOnQtyChange);
    this.dataTransfer.setGroupProdQuantityAndTotal(quantity, code, this.product);
  }
  override ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.sub$) {
      this.sub$.unsubscribe();
    }
    super.ngOnDestroy();
  }
}
